import axios from '../utils/AxiosInstance'
import BlobDownload from '../utils/BlobDownload'

export default {
  // namespaced: true,
  state: {
    candidates: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_CANDIDATE_SELECT_IDS (store, ids) {
      store.candidates.selectIds = ids
    },
    REMOVE_CANDIDATE_SELECT_IDS (store, ids) {
      store.candidates.selectIds = store.candidates.selectIds.filter((v) => { return !ids.includes(v) })
    },
    ADDSTART_CANDIDATE_SELECT_IDS (store, ids) {
      store.candidates.selectIds = ids.concat(store.candidates.selectIds)
    },
    ADDEND_CANDIDATE_SELECT_IDS (store, ids) {
      store.candidates.selectIds = store.candidates.selectIds.concat(ids)
    },
    SET_CANDIDATE_SELECT_ID (store, id) {
      store.candidates.selectId = id
    },
    SET_CANDIDATE_FILTERS (store, filters) {
      store.candidates.filters = filters
    },
    SET_CANDIDATE_PAGINATE (store, val) {
      store.candidates.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getCandidates: (store, getters) => {
      return store.candidates.selectIds.map((id) => {
        return getters['entities/candidates/query']().find(id)
      })
    },
    getCandidatesFilters: (store, getters) => {
      return store.candidates.filters
    },
    getCandidatesPaginate: (store, getters) => {
      return store.candidates.paginate
    },
    getCandidate: (store, getters) => {
      let id = store.candidates.selectId
      return getters['entities/candidates/query']().find(id) || {}
    }
  },
  actions: {
    /*
    selectCandidates
    */
    selectCandidates ({commit, dispatch, getters, state}, filters) {
      return dispatch('getCandidates', { ...filters, abortid: 'select-candidates' })
      .then((response) => {
        commit('SET_CANDIDATE_FILTERS', filters)
        commit('SET_CANDIDATE_PAGINATE', response)
        commit('SET_CANDIDATE_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    selectMoreCandidates
    */
    selectMoreCandidates ({commit, dispatch, getters, state}, filters) {
      return dispatch('getCandidates', { ...filters, abortid: 'select-more-candidates' })
      .then((response) => {
        commit('SET_CANDIDATE_PAGINATE', response)
        commit('ADDEND_CANDIDATE_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectCandidates
    */
    refreshSelectCandidates ({commit, dispatch, getters, state}) {
      return dispatch('selectCandidates', getters.getCandidatesFilters)
    },
    /*
    selectCandidate
    */
    selectCandidate ({commit, dispatch, getters, state}, id) {
      return dispatch('getCandidateById', id)
      .then((response) => {
        commit('SET_CANDIDATE_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getCandidates
    */
    getCandidates ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/candidates`, { params: filters })
      .then((response) => {
        return dispatch('entities/candidates/insertOrUpdate', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: getters['entities/candidates/findIn'](response.data.docs.map(v => v._id)), // insertOrUpdate traz o resultado ordenado
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getCandidateById
    */
    getCandidateById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/candidates/${id}`)
      .then((response) => {
        return dispatch('entities/candidates/insertOrUpdate', {
          data: response.data
        })
      })
      .then((result) => {
        return result.candidates[0]
      })
    },
    /*
    createCandidate
    */
    createCandidate ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/candidates`, data)
      .then((response) => {
        return dispatch('entities/candidates/insertOrUpdate', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('changeCandidate', response.candidates[0])
        return response.candidates[0]
      })
    },
    /*
    updateCandidate
    */
    updateCandidate ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/candidates/${data._id}`, data)
      .then((response) => {
        // console.log(response)
        return dispatch('entities/candidates/insertOrUpdate', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('changeCandidate', response.candidates[0])
        return response.candidates[0]
      })
    },
    /*
    followCandidate
    */
    followCandidate ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/candidates/${data.candidate_id}/${data.action}`)
      .then((response) => {
        return dispatch('entities/candidates/insertOrUpdate', {
          data: response.data
        })
      })
      .then((response) => {
        return response.candidates[0]
      })
    },
    /*
    deleteCandidate
    */
    deleteCandidate ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/candidates/${id}`)
      .then((response) => {
        commit('REMOVE_CANDIDATE_SELECT_IDS', [id])
        commit('REMOVE_CANDIDATEBOARD_SELECT_IDS', [id])
        dispatch('entities/candidates/delete', id)
        dispatch('changeCandidate', {})
        dispatch('setWarn', { status: 'success' })
        return {}
      })
    },
    /*
    parseResume
    */
    parseResume ({commit, dispatch, getters, state}, id) {
      return axios
      .post(`/accounts/${getters.getAccount._id}/candidates/${id}/parse-resume`)
      .then((response) => {
        return dispatch('entities/candidates/insertOrUpdate', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('changeCandidate', response.candidates[0])
        return response.candidates[0]
      })
    },
    /*
    exportCandidate
    */
    exportCandidate ({commit, dispatch, getters, state}, data) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/candidates/${data.candidate_id}/export`, {
        responseType: 'blob',
        params: data.params
      })
      .then((response) => {
        BlobDownload(response)
      })
    },
    /*
    getPlacementsDetail
    */
    getPlacementsDetail ({commit, dispatch, getters, state}, data) {
      return axios.get(`/accounts/${getters.getAccount._id}/candidates/${data.candidate_id}/placements-detail`).then((response) => {
        return response.data
      })
    },
    /*
    requestDiversity
    */
    requestDiversity ({commit, dispatch, getters, state}, data) {
      return axios
      .post(`/accounts/${getters.getAccount._id}/candidates/${data.candidate_id}/request-diversity`)
      .then((response) => {
        return dispatch('entities/candidates/insertOrUpdate', {
          data: response.data
        })
      })
      .then((response) => {
        return response.candidates[0]
      })
    },
    /*
    changeCandidate
    */
    changeCandidate ({commit, dispatch, getters, state}, data) {
      if (data._id) {
        dispatch('selectDuplicates', {candidate_id: data._id})
      }
      if (getters.getJob._id) {
        dispatch('getJobById', getters.getJob._id)
      }
    },
    /*
    socketCandidate
    */
    socketCandidate ({commit, dispatch, getters, state}, message) {
      const {
        method,
        _id
      } = message

      const ids = [...state.candidates.selectIds, state.candidates.selectId]
      if (method === 'update' && ids.includes(_id)) {
        dispatch('getCandidateById', _id)
      }
      if (method === 'delete' && ids.includes(_id)) {
        commit('REMOVE_CANDIDATE_SELECT_IDS', [_id])
        dispatch('entities/candidates/delete', _id)
        if (state.candidates.selectId === _id) {
          commit('SET_CANDIDATE_SELECT_ID', null)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Candidate.js